<template>
  <div class="projectManage">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <!-- <div class="radiobut" v-if="permission.project_audit">
      <el-badge :value="examinelist" class="item">
      <el-radio-group v-model="margintap">
        <el-radio-button label="0">项目管理</el-radio-button>
       
          <el-radio-button label="1">审核列表</el-radio-button>
     
      </el-radio-group>
    </el-badge>
    </div> -->
    <ProjectList v-if="margintap == 0"  @rowdata="rowdata" :files="files" />
    <!-- <Examinelist v-if="margintap == 1" @rowdata="rowdata" :files="files" /> -->
  </div>
</template>

<script>
import * as api from "@/api/zd/project";
import { mapGetters } from "vuex";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import ProjectList from "./components/projectList";
import Examinelist from "./components/examineList";

export default {
  name: "projectManage",
  data() {
    return {
      margintap: 0,
      examinelist: 0,
      authority: false,
      files:[]
    };
  },
  watch: {},
  components: {
    TagsCloud,
    ProjectList,
    Examinelist,
  },
  computed: {
    ...mapGetters(["permission"])
  },
  created() {
    // this.onLoad();
  },
  activated () {
    // this.onLoad()
  },
  methods: {
    onLoad() {
      api
        .getListProject({
          firstNum: 0,
          num: 10,
        })
        .then((res) => {
          this.examinelist = res.data.data.shlb;
          // this.authority = res.data.data.hasAuditRight;
        })
        .catch((res) => {
          
        });
    },
    rowdata(data) {
      this.$refs.cloudtage.save(data);
    },
    cloudTages(data) {
      this.files = data;
      
    }
  },
};
</script>

<style lang="scss" scoped>
.projectManage {
   .radiobut {
    margin: 25px 0;
  }
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .crudblock {
    background: #ffff;
    padding:16px
  }
}
.input_width {
  width: 220px;
}
.advanced_screen {
  color: #409eff;
  display: inline-block;
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
.projectManage .form_wrapper {
  margin: 0 auto;
  .form_header_name {
    font-weight: 400;
    font-size: 13px;
    cursor: pointer;
  }
  .form_content {
    padding: 20px 0;
  }
}
.drawer_wrapper .el-form-item .el-form-item__content {
  margin-left: 120px !important;
  text-align: left;
}
.form_slot {
  display: flex;
}
/deep/.el-badge__content{
  line-height: 17px;
    padding: 0 5px;
}
</style>

